import React from 'react';
import Navigation from './Navigation';

const BettingRooms = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-violet-900">
      <Navigation />
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-white text-center mb-8">🎮 Betting Rooms</h1>
        <div className="casino-card p-8 text-center">
          <p className="text-gray-300 text-lg">Multiplayer betting rooms coming soon!</p>
          <p className="text-gray-400 mt-4">Challenge friends and compete in tournaments</p>
        </div>
      </div>
    </div>
  );
};

export default BettingRooms;